import { useState } from "react";
import ModalResetSenha from "./modalResetDeSenha";
import { useAuth } from "../../../contexts/Auth";
import enqueueSnackbar from "../../../helpers/enqueueSnackbar";

function InputPasswordAuth({ cpf }: { cpf: string }) {
  const { login } = useAuth();

  const [password, setPassword] = useState<string>("");
  const [openModalReset, setOpenModalReset] = useState<boolean>(false);
  const [exibirSenha, setExibirSenha] = useState<boolean>(false);

  async function sendLogin() {
    try {
      await login(cpf, password, "/app/assinar");
    } catch (error) {
      enqueueSnackbar(error.message, "error");
    }
  }

  return (
    <>
      <div
        style={{
          marginTop: 25,
          flexDirection: "column",
          display: "flex",
        }}
      >
        <span
          style={{
            fontWeight: "600",
            fontSize: 16,
            color: "#191919",
          }}
        >
          Digite sua senha do App
        </span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <input
          style={styles.inputStyle}
          value={password}
          type={exibirSenha ? "text" : "password"}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: 15,
          }}
        >
          <button
            style={styles.buttonExibirSenha}
            onClick={() => setExibirSenha(exibirSenha ? false : true)}
          >
            {exibirSenha ? "Esconder senha" : "Exibir senha"}
          </button>
          <button
            style={styles.buttonExibirSenha}
            onClick={() => setOpenModalReset(true)}
          >
            Esqueci minha senha
          </button>
        </div>

        <button style={styles.buttonNext} onClick={() => sendLogin()}>
          Continuar
        </button>
      </div>

      <ModalResetSenha
        open={openModalReset}
        setCloseModal={setOpenModalReset}
        cpf={cpf}
      />
    </>
  );
}

const styles = {
  container: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#141414",
  },
  buttonExibirSenha: {
    border: "none",
    background: "transparent",
    fontWeight: "600",
    textDecorationLine: "underline",
    cursor: "pointer",
    color: "#191919",
  },
  footer: {
    width: "80%",

    borderTopColor: "#E0E0E0",
    borderTopWidth: 1,
  },

  buttonNext: {
    backgroundColor: "#86BFC6",
    width: "100%",
    height: 43,
    borderRadius: 18,
    color: "#fff",
    border: "none",
    fontWeight: "600",
    fontSize: 14,
    cursor: "pointer",
    marginTop: 30,
  },
  inputStyle: {
    borderRadius: 18,
    padding: 16,
    marginTop: 15,
    border: "1px solid #E0E0E0",
    width: "100%",
  },
};

export default InputPasswordAuth;
